<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

  <div
    *ngFor="let item of items; let i = index"
    class="border rounded-lg p-4 bg-white shadow-sm">

    <ng-container *ngIf="editable; else previewMode">

      <input
        [(ngModel)]="item.title"
        [placeholder]="'CREDIT_SECTION.TITLE' | translate"
        class="w-full border rounded px-3 py-2 mb-2">

      <input
        [(ngModel)]="item.value"
        [placeholder]="'CREDIT_SECTION.VALUE' | translate"
        class="w-full border rounded px-3 py-2 mb-3">

      <button
        type="button"
        (click)="removeKpi(i)"
        class="section-delete-btn section-delete-btn-sm">
        {{ 'COMMON.DELETE' | translate }}
      </button>

    </ng-container>

    <ng-template #previewMode>

      <div class="text-sm text-gray-500">
        {{ item.title }}
      </div>

      <div class="text-2xl font-semibold mt-2">
        {{ item.value }}
      </div>

    </ng-template>

  </div>

</div>

<div *ngIf="editable" class="mt-4">

  <button
    type="button"
    (click)="addKpi()"
    class="section-add-btn">

    {{ 'CREDIT_SECTION.ADD_KPI' | translate }}

  </button>

</div>